import React from 'react';
import { MuiColorInput } from 'mui-color-input';
import { useDropzone } from 'react-dropzone';
import Button from '../backend/buttonApp/Button';
import useFontFamilies from '../../hooks/useFontFamilies';

const SearchButtonSettings = ({
  searchConfig,
  onSearchConfigChange,
  buttonColor,
  handleUploadClickSound,
  clickSoundFile,
  setClickSoundFile,
  handleUploadPng,
  uploadingStates,
  btnPng,
  setBtnPng,
}) => {
  const fontOptions = useFontFamilies('option');
  const get = (path, fallback) => {
    try {
      const v = path
        .split('.')
        .reduce((o, k) => (o && o[k] !== undefined ? o[k] : undefined), searchConfig);
      return v !== undefined ? v : fallback;
    } catch (e) {
      return fallback;
    }
  };

  const isPngButtonEnabled = get('pngBtnenabled', false);

  const handleChange = (key, value) => {
    const keys = key.split('.');
    const newConfig = { ...searchConfig };

    keys.reduce((obj, currentKey, index) => {
      if (index === keys.length - 1) {
        obj[currentKey] = value;
      } else {
        obj[currentKey] = { ...obj[currentKey] };
      }
      return obj[currentKey];
    }, newConfig);

    onSearchConfigChange(newConfig);
  };

  const createDropHandler = setMedia => acceptedFiles => {
    if (acceptedFiles.length > 0) {
      setMedia(acceptedFiles[0]);
    }
  };

  return (
    <div>
      <div className="form-group" style={{ marginBottom: '20px' }}>
        <label className="form-label" style={{ fontWeight: '600', marginBottom: '10px' }}>
          Preview
        </label>
        <div
          style={{
            backgroundColor: '#f5f5f5',
            border: '1px solid #ddd',
            borderRadius: '4px',
            padding: '20px',
            minHeight: '100px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Button
            text={searchConfig?.buttonText || 'Search'}
            settings={searchConfig}
            keyid="search-preview"
          />
        </div>
      </div>

      <div className="row menu-card2">
        <div className="col-md-12">
          <div className="form-group">
            <label>Button Text:</label>
            <input
              type="text"
              className="form-control"
              value={get('buttonText', 'Search')}
              onChange={e => handleChange('buttonText', e.target.value)}
            />
          </div>
        </div>
      </div>

      <div className="row menu-card2">
        <div className="col-md-4">
          <div className="form-group">
            <label>Font Line Height:</label>
            <input
              type="number"
              className="form-control"
              value={get('lineHeight', 1)}
              disabled={isPngButtonEnabled}
              onChange={e => handleChange('lineHeight', Number(e.target.value))}
            />
          </div>
        </div>

        <div className="col-md-4">
          <div className="form-group">
            <label>Padding:</label>
            <input
              type="number"
              className="form-control"
              value={get('padding', 10)}
              disabled={isPngButtonEnabled}
              onChange={e => handleChange('padding', Number(e.target.value))}
            />
          </div>
        </div>

        <div className="col-md-4">
          <div className="form-group">
            <label>Margin Bottom:</label>
            <input
              type="number"
              className="form-control"
              value={get('marginBottom', 0)}
              onChange={e => handleChange('marginBottom', Number(e.target.value))}
            />
          </div>
        </div>
      </div>

      <div className="row menu-card2">
        <div className="col-md-4">
          <div className="form-group">
            <label>Corner Radius:</label>
            <input
              type="number"
              className="form-control"
              value={get('cornerRadius', 0)}
              disabled={isPngButtonEnabled}
              onChange={e => handleChange('cornerRadius', Number(e.target.value))}
            />
          </div>
        </div>

        <div className="col-md-4">
          <div className="form-group">
            <label>Height:</label>
            <input
              type="number"
              value={get('height', 50)}
              onChange={e => handleChange('height', Number(e.target.value))}
              className="form-control"
            />
          </div>
        </div>

        <div className="col-md-4">
          <div className="form-group">
            <label>Width:</label>
            <input
              type="number"
              value={get('width', 150)}
              onChange={e => handleChange('width', Number(e.target.value))}
              className="form-control"
            />
          </div>
        </div>
      </div>

      <div className="row menu-card2">
        <div className="col-md-4">
          <div className="form-group">
            <label className="d-flex align-items-center" style={{ height: '21px' }}>
              Outline color: (Transparent
              <input
                type="checkbox"
                className="ml-1 mr-1"
                checked={get('outlineColor', '#000000') === 'transparent'}
                disabled={isPngButtonEnabled}
                onChange={e =>
                  handleChange('outlineColor', e.target.checked ? 'transparent' : '#000000')
                }
              />
              )
            </label>
            <MuiColorInput
              className="form-control mt-1"
              format="hex"
              value={
                get('outlineColor', '#000000') === 'transparent'
                  ? ''
                  : get('outlineColor', '#000000')
              }
              onChange={newHex =>
                handleChange('outlineColor', newHex?.toUpperCase?.() || '#000000')
              }
              fallbackValue="#000000"
              disabled={get('outlineColor', '#000000') === 'transparent' || isPngButtonEnabled}
              isAlphaHidden={true}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '0px !important',
                  height: 53,
                },
                '& .MuiOutlinedInput-input': {
                  height: '36px',
                },
              }}
            />
          </div>
        </div>

        <div className="col-md-4">
          <div className="form-group">
            <label>Outline Thickness:</label>
            <input
              type="number"
              value={get('outlineThickness', 1)}
              disabled={isPngButtonEnabled}
              onChange={e => handleChange('outlineThickness', Number(e.target.value))}
              className="form-control"
            />
          </div>
        </div>

        <div className="col-md-4">
          <div className="form-group">
            <label>Text Alignment:</label>
            <select
              value={get('textAlign', 'center')}
              disabled={isPngButtonEnabled}
              onChange={e => handleChange('textAlign', e.target.value)}
              className="form-select form-control"
            >
              <option value="left">Left</option>
              <option value="center">Center</option>
              <option value="right">Right</option>
            </select>
          </div>
        </div>
      </div>

      <div className="row menu-card2">
        <div className="col-md-3">
          <div className="form-group">
            <label className="d-flex align-items-center" style={{ height: '21px' }}>
              Fill color: (Transparent
              <input
                type="checkbox"
                className="ml-1 mr-1"
                checked={get('fillColor', '#ffffff') === 'transparent'}
                disabled={isPngButtonEnabled}
                onChange={e =>
                  handleChange('fillColor', e.target.checked ? 'transparent' : '#ffffff')
                }
              />
              )
            </label>
            <MuiColorInput
              className="form-control mt-1"
              format="hex"
              value={
                get('fillColor', '#ffffff') === 'transparent' ? '' : get('fillColor', '#ffffff')
              }
              onChange={newHex => handleChange('fillColor', newHex?.toUpperCase?.() || '#ffffff')}
              fallbackValue="#ffffff"
              disabled={get('fillColor', '#ffffff') === 'transparent' || isPngButtonEnabled}
              isAlphaHidden={true}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '0px !important',
                  height: 53,
                },
                '& .MuiOutlinedInput-input': {
                  height: '36px',
                },
              }}
            />
          </div>
        </div>

        <div className="col-md-3">
          <div className="form-group">
            <label>Font Family:</label>
            <select
              value={get('font', 'Arial')}
              onChange={e => handleChange('font', e.target.value)}
              className="form-select form-control"
            >
              {fontOptions}
            </select>
          </div>
        </div>

        <div className="col-md-3">
          <div className="form-group">
            <label className="d-flex align-items-center" style={{ height: '21px' }}>
              Font color: (Transparent
              <input
                type="checkbox"
                className="ml-1 mr-1"
                checked={get('fontColor', '#127E10') === 'transparent'}
                onChange={e =>
                  handleChange('fontColor', e.target.checked ? 'transparent' : '#127E10')
                }
              />
              )
            </label>
            <MuiColorInput
              className="form-control mt-1"
              format="hex"
              value={
                get('fontColor', '#127E10') === 'transparent' ? '' : get('fontColor', '#127E10')
              }
              onChange={newHex => handleChange('fontColor', newHex?.toUpperCase?.() || '#127E10')}
              fallbackValue="#127E10"
              disabled={get('fontColor', '#127E10') === 'transparent'}
              isAlphaHidden={true}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '0px !important',
                  height: 53,
                },
                '& .MuiOutlinedInput-input': {
                  height: '36px',
                },
              }}
            />
          </div>
        </div>

        <div className="col-md-3">
          <div className="form-group">
            <label>Font Size:</label>
            <input
              type="number"
              value={get('fontSize', 16)}
              onChange={e => handleChange('fontSize', Number(e.target.value))}
              className="form-control"
            />
          </div>
        </div>
      </div>

      {/* Shadow Settings */}
      <div className="row menu-card2">
        <div className="col-md-2">
          <div className="form-group">
            <label>Shadow angle:</label>
            <input
              type="number"
              className="form-control"
              value={get('shadow.angle', 5)}
              disabled={isPngButtonEnabled}
              onChange={e => handleChange('shadow.angle', Number(e.target.value))}
            />
          </div>
        </div>

        <div className="col-md-2">
          <div className="form-group">
            <label>Shadow size:</label>
            <input
              type="number"
              value={get('shadow.size', 10)}
              disabled={isPngButtonEnabled}
              onChange={e => handleChange('shadow.size', Number(e.target.value))}
              className="form-control"
            />
          </div>
        </div>

        <div className="col-md-2">
          <div className="form-group">
            <label>Shadow distance:</label>
            <input
              type="number"
              value={get('shadow.distance', 5)}
              disabled={isPngButtonEnabled}
              onChange={e => handleChange('shadow.distance', Number(e.target.value))}
              className="form-control"
            />
          </div>
        </div>

        <div className="col-md-2">
          <div className="form-group">
            <label>Shadow Alpha:</label>
            <input
              type="number"
              value={get('shadow.alpha', 0.5)}
              disabled={isPngButtonEnabled}
              onChange={e => handleChange('shadow.alpha', Number(e.target.value))}
              className="form-control"
              step="0.1"
              min="0"
              max="1"
            />
          </div>
        </div>

        <div className="col-md-4">
          <div className="form-group">
            <label className="d-flex align-items-center" style={{ height: '25px' }}>
              Shadow color: (Transparent
              <input
                type="checkbox"
                className="ml-1 mr-1"
                checked={get('shadow.color', '#FF5733') === 'transparent'}
                disabled={isPngButtonEnabled}
                onChange={e =>
                  handleChange('shadow.color', e.target.checked ? 'transparent' : '#FF5733')
                }
              />
              )
            </label>
            <MuiColorInput
              className="form-control mt-1"
              format="hex"
              value={
                get('shadow.color', '#FF5733') === 'transparent'
                  ? ''
                  : get('shadow.color', '#FF5733')
              }
              onChange={newHex =>
                handleChange('shadow.color', newHex?.toUpperCase?.() || '#FF5733')
              }
              fallbackValue="#FF5733"
              disabled={get('shadow.color', '#FF5733') === 'transparent' || isPngButtonEnabled}
              isAlphaHidden={true}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '0px !important',
                  height: 53,
                },
                '& .MuiOutlinedInput-input': {
                  height: '36px',
                },
              }}
            />
          </div>
        </div>
      </div>

      {/* Highlight Settings */}
      <div className="row menu-card2">
        <div className="col-md-4">
          <div className="form-group">
            <label className="d-flex align-items-center" style={{ height: '21px' }}>
              Highlight border color: (Transparent
              <input
                type="checkbox"
                className="ml-1 mr-1"
                disabled={isPngButtonEnabled}
                checked={get('highlight.borderColor', '#000000') === 'transparent'}
                onChange={e =>
                  handleChange(
                    'highlight.borderColor',
                    e.target.checked ? 'transparent' : '#000000'
                  )
                }
              />
              )
            </label>
            <MuiColorInput
              className="form-control mt-1"
              format="hex"
              value={
                get('highlight.borderColor', '#000000') === 'transparent'
                  ? ''
                  : get('highlight.borderColor', '#000000')
              }
              onChange={newHex =>
                handleChange('highlight.borderColor', newHex?.toUpperCase?.() || '#000000')
              }
              fallbackValue="#000000"
              disabled={
                get('highlight.borderColor', '#000000') === 'transparent' || isPngButtonEnabled
              }
              isAlphaHidden={true}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '0px !important',
                  height: 53,
                },
                '& .MuiOutlinedInput-input': {
                  height: '36px',
                },
              }}
            />
          </div>
        </div>

        <div className="col-md-4">
          <div className="form-group">
            <label className="d-flex align-items-center" style={{ height: '21px' }}>
              Highlight fill color: (Transparent
              <input
                type="checkbox"
                className="ml-1 mr-1"
                disabled={isPngButtonEnabled}
                checked={get('highlight.fillColor', '#ffffff') === 'transparent'}
                onChange={e =>
                  handleChange('highlight.fillColor', e.target.checked ? 'transparent' : '#ffffff')
                }
              />
              )
            </label>
            <MuiColorInput
              className="form-control mt-1"
              format="hex"
              value={
                get('highlight.fillColor', '#ffffff') === 'transparent'
                  ? ''
                  : get('highlight.fillColor', '#ffffff')
              }
              onChange={newHex =>
                handleChange('highlight.fillColor', newHex?.toUpperCase?.() || '#ffffff')
              }
              fallbackValue="#ffffff"
              disabled={
                get('highlight.fillColor', '#ffffff') === 'transparent' || isPngButtonEnabled
              }
              isAlphaHidden={true}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '0px !important',
                  height: 53,
                },
                '& .MuiOutlinedInput-input': {
                  height: '36px',
                },
              }}
            />
          </div>
        </div>

        <div className="col-md-4">
          <div className="form-group">
            <label className="d-flex align-items-center" style={{ height: '25px' }}>
              Highlight Font color: (Transparent
              <input
                type="checkbox"
                className="ml-1 mr-1"
                disabled={isPngButtonEnabled}
                checked={get('highlight.fontColor', '#000000') === 'transparent'}
                onChange={e =>
                  handleChange('highlight.fontColor', e.target.checked ? 'transparent' : '#000000')
                }
              />
              )
            </label>
            <MuiColorInput
              className="form-control mt-1"
              format="hex"
              value={
                get('highlight.fontColor', '#000000') === 'transparent'
                  ? ''
                  : get('highlight.fontColor', '#000000')
              }
              onChange={newHex =>
                handleChange('highlight.fontColor', newHex?.toUpperCase?.() || '#000000')
              }
              fallbackValue="#000000"
              disabled={
                get('highlight.fontColor', '#000000') === 'transparent' || isPngButtonEnabled
              }
              isAlphaHidden={true}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '0px !important',
                  height: 53,
                },
                '& .MuiOutlinedInput-input': {
                  height: '36px',
                },
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchButtonSettings;
